export enum GraphQlRequestErrorCode {
  query = 'query',
  Err_AuthorizationDenied = 'Err_AuthorizationDenied',
  Err_RoleNotFound = 'Err_RoleNotFound',
  Err_UserNotFound = 'Err_UserNotFound',
  Err_EmployeeNotFound = 'Err_EmployeeNotFound',
  Err_OrganizationPathNotFound = 'Err_OrganizationPathNotFound',
  Err_NoLatestVersionFound = 'Err_NoLatestVersionFound',
  Err_NoFirstVersionFound = 'Err_NoFirstVersionFound',
  Err_ReportNotFound = 'Err_ReportNotFound',
  Err_DashboardNotFound = 'Err_DashboardNotFound',
  Err_AliasNotFound = 'Err_AliasNotFound',
  Err_PermissionIdNotFound = 'Err_PermissionIdNotFound',
  Err_DomainSettingsNotFound = 'Err_DomainSettingsNotFound',
  Err_DomainSettingsVersionNotFound = 'Err_DomainSettingsVersionNotFound',
  Err_DomainPreferencesNotFound = 'Err_DomainPreferencesNotFound',
  Err_DomainPreferencesVersionNotFound = 'Err_DomainPreferencesVersionNotFound',
  Err_RolePreferencesNotFound = 'Err_RolePreferencesNotFound',
  Err_RolePreferencesVersionNotFound = 'Err_RolePreferencesVersionNotFound',
  Err_UserAlreadyExists = 'Err_UserAlreadyExists',
  Err_MetaDataError = 'Err_MetaDataError',
  Err_SameNameRoleAlreadyExists = 'Err_SameNameRoleAlreadyExists',
  Err_QueryExecutionError = 'Err_QueryExecutionError',
  Err_MultipleEmployeesForId = 'Err_MultipleEmployeesForId',
  Err_AmbiguousPopFilter = 'Err_AmbiguousPopFilter',
  Err_NoReadDataPermissions = 'Err_NoReadDataPermissions',
  Err_AmbiguousReadDataPermissions = 'Err_AmbiguousReadDataPermissions',
  Err_DeleteFileFailed = 'Err_DeleteFileFailed',
  Err_ListFilesFailed = 'Err_ListFilesFailed',
  Err_GetBucketFailed = 'Err_GetBucketFailed',
  Err_CreateBucketFailed = 'Err_CreateBucketFailed',
  Err_CreateFolderFailed = 'Err_CreateFolderFailed',
  Err_CreateFoldersFailed = 'Err_CreateFoldersFailed',
  Err_FilterInvalid = 'Err_FilterInvalid',
  Err_SendingEmailError = 'Err_SendingEmailError',
  Err_ExternalSystemUserCreationError = 'Err_ExternalSystemUserCreationError',
  Err_ResetPasswordError = 'Err_ResetPasswordError',
  Err_ValidationFailed = 'Err_ValidationFailed',
  Err_Unspecified = 'Err_Unspecified',
  Err_DomainAccessDeniedWrongAuthMethod = 'Err_DomainAccessDeniedWrongAuthMethod',
  Err_DomainAccessDeniedNotEnabled = 'Err_DomainAccessDeniedNotEnabled',
  Err_RateLimitExceeded = 'Err_RateLimitExceeded',
  Err_DomainAccessDeniedIpForbidden = 'Err_DomainAccessDeniedIpForbidden',
}

export interface QueryErrorEntity {
  code: GraphQlRequestErrorCode;
  errorReference: string;
}

export const getGraphqlResult = <T>(result: T | null): T => {
  if (result === null) {
    throw new Error(`Unexpected state - null value found for graphql response. This should never happen as
    the function should throw an error before reaching this point, since null response only happens in case
    of errors`);
  } else {
    return result;
  }
};

export const getErrorCodeFromError = (error: any) => {
  return error?.response?.errors?.[0].extensions?.errorCode;
};
